const dateInput = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

const futureDate = (days) => {
  const value = new Date();
  value.setDate(value.getDate() + days);
  return dateInput(value);
};

export const defaultLicense = () => ({
  status: 'trial',
  starts_at: dateInput(new Date()),
  expires_at: futureDate(30),
  grace_ends_at: futureDate(37),
  licensed_total_seats: 10,
  // A named user may use both clients. Web/mobile are membership enable flags,
  // not separately licensed seat pools.
  licensed_web_users: null,
  feature_entitlements: {
    reports: true,
    iot: true,
    api_connections: true,
    foresight: true,
    scenario_marketplace: false,
    partners: true,
  },
  grace_access_mode: 'read_only',
  expired_access_mode: 'deny',
  expected_version: 0,
});

export const toLicenseForm = (license) => {
  const defaults = defaultLicense();
  const featureEntitlements = {
    ...defaults.feature_entitlements,
    ...(license?.feature_entitlements || {}),
  };
  if (featureEntitlements.api_connections === false) featureEntitlements.foresight = false;
  return {
    ...defaults,
    ...(license || {}),
    feature_entitlements: featureEntitlements,
    starts_at: dateInput(license?.starts_at) || dateInput(new Date()),
    expires_at: dateInput(license?.expires_at) || futureDate(30),
    grace_ends_at: dateInput(license?.grace_ends_at),
    expected_version: license?.current_version || 0,
  };
};

export const licensePayload = (form) => {
  const featureEntitlements = { ...(form.feature_entitlements || {}) };
  if (featureEntitlements.api_connections === false) featureEntitlements.foresight = false;
  return {
    status: form.status,
    starts_at: new Date(form.starts_at).toISOString(),
    expires_at: new Date(form.expires_at).toISOString(),
    grace_ends_at: form.grace_ends_at ? new Date(form.grace_ends_at).toISOString() : null,
    licensed_total_seats: Number(form.licensed_total_seats),
    licensed_web_users: null,
    feature_entitlements: featureEntitlements,
    grace_access_mode: form.grace_access_mode,
    expired_access_mode: form.expired_access_mode,
    expected_version: Number(form.expected_version || 0),
  };
};
